import React, { Component } from 'react'
import { connect } from 'react-redux'

import NavigationBar from '../../components/NavigationBar'
import FixedFooter from '../../components/FixedFooter'
import FbWrapper from '../../lib/FirebaseWrapper'

import GoogleSignInIcon from './btn_google_signin_light_normal_web@2x.png'

const styles = {
  body: {
    display: 'grid',
    width: '100vw',
    height: '100vh',
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: '50px'
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: 450,
    height: 500,
    backgroundColor: '#4990E2',
    boxShadow: `10px 30px 70px #9E9E9E`,
    alignItems: 'center'
  },
  iconRow: {
    display: 'flex',
    flexGrow: 0,
    height: 120,
    justifyContent: 'center',
    alignItems: 'center'
  },
  signInIcon: {
    width: 280
  },
  options: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'white'
  }
}

class LoginView extends Component {
  constructor (props) {
    super(props)
    this.state = {
      token: undefined,
    }

    FbWrapper.onAuthStateChanged(user => {
      this.props.onSetAuthUser(user ? user : null)
      if (user) this.props.history.push('/')
    })
  }

  render () {
    var logInbuttons = () =>
      <div style={{display: 'flex', flexDirection: 'column'}}>
        <img
          style={styles.signInIcon}
          src={GoogleSignInIcon}
          alt='Sign In with Google'
          onClick={() => this.handleSignOn('google')}
        />
      </div>

    return (
      <div>
        <NavigationBar history={this.props.history} />
        <div style={styles.body}>
          <div style={styles.container}>
            <div style={styles.iconRow}>
              <img className='navi-logo' src='/logo.svg' alt='logo' />
            </div>
            <div style={styles.options}>
              {logInbuttons()}
            </div>
          </div>
        </div>
        <FixedFooter />
      </div>
    )
  }

  handleSignOn (type) {
    var callback = (token, user) => {
      console.log(token)
      console.log(user)
    }
    if (type === 'facebook') {
      FbWrapper.handleFacebookLogin(callback)
    } else {
      FbWrapper.handleGoogleLogin(callback)
    }
  }

  handleSignOut () {
    FbWrapper.handleSignOut()
  }
}

const mapStateToProps = (state) => ({
  authUser: state.sessionState.authUser
})

const mapDispatchToProps = (dispatch) => ({
  onSetAuthUser: (authUser) => dispatch({ type: 'AUTH_USER_SET', authUser })
})

export default connect(mapStateToProps, mapDispatchToProps)(LoginView)



// WEBPACK FOOTER //
// ./src/views/Authentication/LoginView.js